/* lua.js generated code undefined */

const Event = require("cocos/framework/components/event")
DATargetCountGUILogger = xClass("DATargetCountGUILogger", Event)
let _instance = null
DATargetCountGUILogger.getInstance = function () {
    let self = this
    if (!_instance) {
        _instance = DATargetCountGUILogger.new()
    }
    return _instance
}
DATargetCountGUILogger.prototype.ctor = function () {
    let self = this
    // 关卡信息
    self._levelInfoStr = ""
}
// DATargetCountGUILogger.prototype.showDropAdjustLoggerInGameScene = function (levelInfoStr, isV2) {
//     let self = this
//     self._levelInfoStr = levelInfoStr
//     self._removeDropAdjustLogger()
//     self._showDropAdjustLoggerInGameScene = true
//     self.isV2 = isV2 || false
//     self.updateLoggerInGameScene()
// }
DATargetCountGUILogger.prototype.updateLoggerInGameScene = function () {
    let self = this
    // if (!self._showDropAdjustLoggerInGameScene) {
    //     return 
    // }
    // let width = 600
    // let height = 300
    // let padding = 10
    // if (!self.dropAdjustLogLayer || tolua.isnull(self.dropAdjustLogLayer)) {
    //     let scene = cc.Director.getInstance().getRunningScene()
    //     let max = 70
    //     let layer = cc.LayerColor.create(cc.c4b(0, 0, 0, 180), width, height)
    //     layer.setPosition((display.width - width) / 2, display.height - height)
    //     scene.addChild(layer, 999999)
    //     self.dropAdjustLogLayer = layer
    //     let sprite = UnionUIHelper.createSprite("uilibrary/off_btn_light.png", width - 30, height - 30, 2, null)
    //     layer.addChild(sprite, 10)
    //     let button = UIButton.create(sprite, true)
    //     button.on(UIButtonEvent.Click, function () {
    //         self._removeDropAdjustLogger()
    //     })
    //     PushBounceAnim.create(button)
    //     let scrollView = ccui.ScrollView.create()
    //     scrollView.setTouchEnabled(true)
    //     scrollView.setContentSize(cc.size(width, height))
    //     scrollView.setClippingType(1)
    //     scrollView.setBounceEnabled(true)
    //     scrollView.setDirection(ccui.ScrollViewDir.vertical)
    //     layer.addChild(scrollView)
    //     let label = cc.Label.createWithSystemFont("", "Arial", 25)
    //     label.setAnchorPoint(ccp(0, 1))
    //     label.setPosition(ccp(padding, height))
    //     label.setWidth(width - padding * 2)
    //     scrollView.getInnerContainer().addChild(label)
    //     self.dropAdjustLogLabel = label
    //     self.dropAdjustLogLabel.scrollView = scrollView
    // }
    // if (self.dropAdjustLogLabel && !tolua.isnull(self.dropAdjustLogLabel)) {
    //     let str = self._convertTargetListToString()
    //     str = str + "\n-------------------------\n打点：\n" + DATargetCounter.getInstance()._getFinalFormatStr(true)
    //     self.dropAdjustLogLabel.setString(str)
    //     let size = self.dropAdjustLogLabel.getContentSize()
    //     let contentHeight = Math.max(size.height, height)
    //     self.dropAdjustLogLabel.setPosition(ccp(padding, contentHeight))
    //     self.dropAdjustLogLabel.scrollView.setInnerContainerSize(cc.size(width, contentHeight))
    //     self.dropAdjustLogLabel.scrollView.scrollToBottom(0.2, false)
    // }

    //老
    // let str = self._convertTargetListToString(false);
    // str = str + "\n-------------------------\n老打点：\n"
    // str = str + DATargetCounter.getInstance()._getFinalFormatStr(true)
    // console.log(str);

    let str = self._convertTargetListToString(true);
    str = str + "\n-------------------------\n新打点：\n"
    str = str + DATargetCounterV2.getInstance()._getFinalFormatStr(true)
    console.log(str);
}
DATargetCountGUILogger.prototype._removeDropAdjustLogger = function () {
    // let self = this
    // if (self.dropAdjustLogLabel && !tolua.isnull(self.dropAdjustLogLabel)) {
    //     self.dropAdjustLogLabel.removeFromParent(true)
    //     self.dropAdjustLogLabel = null
    // }
    // if (self.dropAdjustLogLayer && !tolua.isnull(self.dropAdjustLogLayer)) {
    //     self.dropAdjustLogLayer.removeFromParent(true)
    //     self.dropAdjustLogLayer = null
    // }
    // self._showDropAdjustLoggerInGameScene = false
}
DATargetCountGUILogger.prototype._convertTargetListToString = function (isV2) {
    let self = this
    let countList = ""
    cc.log("#### fuuu _convertTargetListToString isV2=" + tostring(isV2))
    if (isV2) {
        countList = DATargetCounterV2.getInstance()._targetCountList
    } else {
        countList = DATargetCounter.getInstance()._targetCountList
    }
    cc.log("#### fuuu countList=" + table.tostring(countList))
    let str = "掉落优化计数统计 V2=" + tostring(isV2) + "\n" + self._levelInfoStr + "\n"
    for (let i = 1, data = countList[1]; data; i++, data = countList[i]) {
        str = str + "Step" + i + "\n            "
        let hasCount = false
        for (let itemType in data) {
            let count = data[itemType]
            if ($null(count)) continue
            str = str + itemType + ": " + count + "    "
            hasCount = true
        }
        if (!hasCount) {
            str = str + "--"
        }
        if (i !== $len(countList)) {
            str = str + "\n"
        }
    }
    return str
}
